import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormViewComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { FormEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { FileConstants, IconDefinitionConstants } from "utils/constants";
import { DocumentFormTypes } from "models/formTypes";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion

const GenericDocumentUploadForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (props, ref) => {
  return (
    <GenericForm<DocumentFormTypes.UploadGenericDocument>
      formRef={ref}
      {...props}
      fields={{
        files: {
          label: "",
          type: FormEnums.FormFieldType.FILEUPLOADER,
          extraProps: {
            fileUploaderType: "full",
            filePreviewElementId: FileConstants.DialogFilePreviewPortalId,
          },
        },
        comment: {
          label: TranslationKeys.Common.Comment,
          type: FormEnums.FormFieldType.TEXTAREA,
          icon: IconDefinitionConstants.WCommentDots,
        },
      }}
      hideSuccess
    />
  );
};

export default forwardRef(GenericDocumentUploadForm);
